
import React from 'react';
import styles from './Contact.module.css';
import { TextField } from '@material-ui/core';
import {FaUser } from 'react-icons/fa';
import { Mail } from '@mui/icons-material';
import InputAdornment from '@material-ui/core/InputAdornment';
import emailjs from '@emailjs/browser';
import { CircularProgress } from '@material-ui/core';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert } from '@mui/material';
import Aos from 'aos';
import 'aos/dist/aos.css';




export default function Contact () {


  React.useEffect(() => {
    Aos.init({duration: 1500})
  }, [])

  const [loading, set_loading] = React.useState(false);
  const [open, set_open] = React.useState({
    state: false,
    message: '',
    type: ''
  })

  const [data, set_data] = React.useState({
    from_name: "",
    to_name: "Ezelu",
    message: "",
    reply_to: "",
  });

  function handle_data (e) {
    set_data(prev => ({
      ...prev,
      [e.target.name] : e.target.value,
    }))
  }

  async function handle_submit (e) {
    e.preventDefault();

    if(data.from_name.trim().length < 1 || data.reply_to.trim().length < 1 || data.message.trim().length < 1) {
      set_open({
        state: true,
        message: 'Fill all field please',
        type: 'error'
      })
      return false;
    }

    set_loading(true)
    await emailjs.send("service_p26ptya", "template_2jxc3ky", data, 'CsoYQC9Vl8AJ-NN65')
      .then((result) => {
          set_open({
            state: true,
            message: "Thanks for reaching Out!",
            type: 'success'
          });
          set_loading(false);

          set_data ({
            from_name: "",
            to_name: "Ezelu",
            message: "Hi, I think we need a developer to help us at company XYZ. Are you chanced so we can schedule a meeting?",
            reply_to: "",
          })

      }, (error) => {
          set_loading(false);
      });

  }


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    set_open(false);
  };



  return (
    <div className={styles.container} data-aos='fade-up'>
      <h2> Send Me A Message! </h2>
      <p> Got a question or a proposal?... Or you just wanna say hi?... </p> 
      <p> Go Ahead! 😊  </p>
      <form action="#" method="GET">
        <aside>
          <TextField 
            type='text' 
            variant='standard' 
            label='Your Name' 
            name='from_name'
            value = {data.from_name}
            className={styles.input}
            InputProps={{ startAdornment: <InputAdornment position="start"> <FaUser /> </InputAdornment>, }}
            onChange = {handle_data}
            required
          />

          <TextField 
            type='email' 
            variant='standard' 
            label='Your Email'
            name='reply_to'
            value = {data.reply_to}
            className={styles.input}
            InputProps={{ startAdornment: <InputAdornment position="start"> <Mail /> </InputAdornment>, }}
            onChange = {handle_data}
            required
            />

        </aside>
        <TextField
          label="Your Message"
          multiline
          rows={4}
          placeholder = "Hi, I think we need a developer to help us at company XYZ. Are you chanced so we can schedule a meeting?"
          name="message"
          value = {data.message}
          fullWidth
          onChange = {handle_data}
          required
        />

        <button className={styles.button} onClick={handle_submit}> 
          {loading ? 
            <CircularProgress style={{color: 'white'}} /> : 
            "Shoot!" 
          } </button> 
      </form>

      <Snackbar open={open.state} autoHideDuration={3000} onClose={handleClose} sx={{ width: '80%' }}>
        <Alert onClose={handleClose} severity={open.type} sx={{ width: '80%' }}>
          {open.message}
        </Alert>
      </Snackbar>
    </div>
  )
}